export function createNum({ name, initialState = 0, }) {
    return {
        name: name,
        schema: "num",
        initialState,
        set: (value) => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] = value;
        },
        increment: (by = 1) => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] += by;
        },
        decrement: (by = 1) => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] -= by;
        },
        reset: () => (state) => {
            // deno-lint-ignore no-explicit-any
            state[name] = initialState;
        },
        select: (state) => {
            // deno-lint-ignore no-explicit-any
            return state[name];
        },
    };
}
export function num(initialState) {
    return (name) => createNum({ name, initialState });
}
